import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType} from '../../constants';

export class GATrackingVolumePriceSelectedEvent implements GATrackingEvent {

  constructor() {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.VolumePriceSelected;
  }

  getPayload(): GATrackingEventPayload {

    return {
      event: GaTrackingEventName.VolumePricingClick,
      label: '',
      gtmCustom: {
        category: GaTrackingEventCategory.Interaction
      }
    };
  }
}
